import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { EventItemStyled } from "./styled";

const EventItem = ({ theme_standard, name, event, color }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <EventItemStyled className={customClass} color={color}>
      <div className="event_item_color" />
      <div className="event_item_box">
        <div className="event_item_name">{name}</div>
        <div className="event_item_event">{event}</div>
      </div>
    </EventItemStyled>
  );
};

EventItem.propTypes = {};

export default EventItem;
